<template lang="pug">
v-form.e-receipt-creation-form(ref="form")
  v-container.pa-0(fluid)
    base-text-divider 基本資料
    v-layout(wrap)
      v-flex(
        xs12
        sm6)
        v-text-field(
          :value="user.displayName"
          label="會員姓名"
          disabled)
      v-flex(
        xs12
        sm6)
        v-text-field(
          :value="formMixin_profile.displayName"
          label="經手人"
          disabled)
    base-text-divider 收據資料
    v-layout(wrap)
      v-flex(xs12)            
        v-checkbox(
          v-model="needPaper"
          label="是否需寄送紙本收據")
      v-flex(xs12)
        v-checkbox(
          v-model="paperInvoiced"
          label="是否已開立紙本收據")
      v-flex(
        v-if="managerPermission"
        xs12)
        v-checkbox(
          v-model="isOld"
          label="是否屬於舊收據（不會編入流水號）")
    base-text-divider 款項內容
    v-layout
      v-flex
        receipt-item-fieldset(ref="itemFieldset")
    base-text-divider 表單動作
    form-actions(
      :loading="formMixin_loading || isFetching"
      @cancel="$emit('cancel')"
      @submit="submit") {{ formMixin_message }}
</template>
<script>
import { mapGetters } from "vuex";
import get from "lodash/get";
import { required } from "vuelidate/lib/validators";
import { formMixin } from "@/mixins";
import ReceiptItemFieldset from "@/components/core/ReceiptItemFieldset.vue";

export default {
  name: "EReceiptCreationForm",
  mixins: [formMixin],
  validations: {
    items: { required }
  },
  components: {
    ReceiptItemFieldset
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      needPaper: false,
      paperInvoiced: false,
      isOld: false,
      items: [],
      isFetching: false
    };
  },
  computed: {
    ...mapGetters("auth", ["role"]),
    managerPermission() {
      return ["super", "admin", "manager"].indexOf(this.role) !== -1;
    },
    payer() {
      return get(this.user, "uid", null);
    },
    payee() {
      return this.formMixin_profile.uid;
    }
  },
  methods: {
    reset() {
      this.$refs.form.reset();
    },
    async submit() {
      try {
        this.isFetching = true;

        const items = this.$refs.itemFieldset.submit();
        if (!items) return false;

        this.items = items;

        const fields = [
          "payer",
          "payee",
          "needPaper",
          "paperInvoiced",
          "isOld",
          "items"
        ];

        const res = await this.formMixin_submit(fields, "post", "receipt");
      } finally {
        this.isFetching = false;
      }
    }
  }
};
</script>
